module.exports = __webpack_public_path__ + "img/55.1bbb8e19.png";